"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[959,272],{

/***/ 6319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ formatTimeToISO; }
/* harmony export */ });
var formatTimeToISO = function formatTimeToISO(d) {
  if (!d) {
    return '';
  }

  return new Date(d).toISOString();
};

/***/ }),

/***/ 1332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ useImageProxy; }
/* harmony export */ });
var prod = true; // const image_proxy_url = process.env.NEXT_PUBLIC_WEBAPP_IMAGE_ADDRESS
// function to stringify url image to pass in image proxy 

function useImageProxy(url, enabled) {
  if (!prod || !enabled || !url || url == 'undefined') {
    return url;
  }

  var value = "/image/".concat(url.replace('/image/', ''));
  return value;
}

/***/ }),

/***/ 6521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ArticleContext": function() { return /* binding */ ArticleContext; }
/* harmony export */ });
/* harmony import */ var providers_Pages__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9859);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);



var ArticleContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});

var ArticleProvider = function ArticleProvider(_ref) {
  var _pagesContext$article, _pagesContext$article2;

  var children = _ref.children;
  var pagesContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(providers_Pages__WEBPACK_IMPORTED_MODULE_0__.PagesContext);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoaded = _useState[0],
      setIsLoaded = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      viewed = _useState2[0],
      setViewed = _useState2[1];

  function handleClearStates() {
    setIsLoaded(false);
    setViewed([]);
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(ArticleContext.Provider, {
    value: {
      articleId: (pagesContext === null || pagesContext === void 0 ? void 0 : (_pagesContext$article = pagesContext.articles) === null || _pagesContext$article === void 0 ? void 0 : (_pagesContext$article2 = _pagesContext$article[0]) === null || _pagesContext$article2 === void 0 ? void 0 : _pagesContext$article2.id) || "",
      articles: pagesContext.articles,
      isLoaded: isLoaded,
      viewed: viewed,
      setIsLoaded: setIsLoaded,
      clearState: handleClearStates
    },
    children: children
  });
};

/* harmony default export */ __webpack_exports__["default"] = (ArticleProvider);

/***/ }),

/***/ 6880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ArticleScrollContext": function() { return /* binding */ ArticleScrollContext; },
  "default": function() { return /* binding */ ArticleScroll; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(7812);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./formatters/parseTime.ts
var parseTime = __webpack_require__(6319);
// EXTERNAL MODULE: ./hooks/useImageProxy.tsx
var useImageProxy = __webpack_require__(1332);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./providers/Article/index.tsx
var Article = __webpack_require__(6521);
;// CONCATENATED MODULE: ./providers/ArticleScroll/searchArticleCid.ts
function searchArticleCid(slug) {
  function extractCid(data) {
    var cid = data.match(/1\..*/);
    return cid !== null && cid !== void 0 && cid.length ? cid === null || cid === void 0 ? void 0 : cid[0] : null;
  }

  var cid = extractCid(slug);

  if (cid) {
    return {
      type: 'article'
    };
  } else {
    return {
      type: ''
    };
  }
}
// EXTERNAL MODULE: ./providers/ServerSideProps/index.tsx + 538 modules
var ServerSideProps = __webpack_require__(8991);
// EXTERNAL MODULE: ./utils/ecryption.ts
var ecryption = __webpack_require__(3119);
// EXTERNAL MODULE: ./node_modules/@react-keycloak/ssr/lib/index.js + 14 modules
var lib = __webpack_require__(5069);
// EXTERNAL MODULE: ./utils/getDepFromNav.js
var getDepFromNav = __webpack_require__(586);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./providers/ArticleScroll/index.tsx


/* eslint-disable react-hooks/rules-of-hooks */

/* eslint-disable react-hooks/exhaustive-deps */







 // import { enviarScroll, enviarPageView } from "hooks/useGCJAnalytics";





var ArticleScrollContext = /*#__PURE__*/(0,react.createContext)({});

var ArticleScrollProvider = function ArticleScrollProvider(props) {
  var serverSideContext = (0,react.useContext)(ServerSideProps.ServerSidePropsContext);
  var articleContext = (0,react.useContext)(Article.ArticleContext);

  var _useKeycloak = (0,lib.useKeycloak)(),
      keycloak = _useKeycloak.keycloak;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)({}),
      state = _useState[0],
      setState = _useState[1];

  var scrollListenerController = new AbortController();
  var privateViewedState = [];

  function calculatePos(elements) {
    var keys = Object.keys(elements);
    var state = {};
    keys.forEach(function (i, k) {
      var articleElement = elements[i];
      var elementArticleId = articleElement.dataset.articleId;
      var elementArticleUrl = articleElement.dataset.articleUrl;
      var elementHeight = articleElement.clientHeight;
      var pos = articleElement.getBoundingClientRect();
      var topGutter = 198;
      state[elementArticleId] = {
        viewing: k === 0 ? true : false,
        viewed: false,
        top: (pos.top - topGutter) * -1,
        bottom: pos.bottom,
        height: elementHeight,
        progress: 0,
        url: elementArticleUrl
      };
    });
    return state;
  }

  var nav = serverSideContext.navigation || {};
  var fullNav = [];
  var prevNav = [].concat((0,toConsumableArray/* default */.Z)(nav === null || nav === void 0 ? void 0 : nav.menuActions), (0,toConsumableArray/* default */.Z)(nav === null || nav === void 0 ? void 0 : nav.menuSide), (0,toConsumableArray/* default */.Z)(nav === null || nav === void 0 ? void 0 : nav.menuTop));
  var lastArticleId = "";
  var lastAnalyticsScroll = -1;

  for (var i = 0; i < prevNav.length; i++) {
    var it = prevNav[i];
    fullNav.push({
      name: it === null || it === void 0 ? void 0 : it.name,
      path: it === null || it === void 0 ? void 0 : it.path
    });
    var subItems = (it === null || it === void 0 ? void 0 : it.subItems) || [];

    for (var j = 0; j < subItems.length; j++) {
      var sit = subItems[j];
      fullNav.push({
        name: sit === null || sit === void 0 ? void 0 : sit.name,
        path: sit === null || sit === void 0 ? void 0 : sit.path
      });
    }
  }

  function parseArticleKeywords(tags) {
    if (!tags) {
      return "";
    }

    return tags.join(", ");
  }

  function parseMainSection(path) {
    var navItems = path ? (0,getDepFromNav/* getPageTitleFromPath */.$)(fullNav, path) : [];
    return navItems[0] ? navItems[0] : "";
  }

  function handleScroll() {
    var elements = window.document.querySelectorAll('div[data-component-type="article"]');
    var s = calculatePos(elements);
    var keys = Object.keys(s);
    var newState = {};
    keys.forEach(function (k, index) {
      var i = s[k];
      var x = i.top * 100 / i.height;
      var percentageViewed = Number(x.toFixed(3));
      var progress = percentageViewed > 100 ? 100 : percentageViewed < 0 ? 0 : percentageViewed;
      var progressAnalytics = Math.floor(progress);
      var percentSendAnalytics = progressAnalytics % 10;
      var isViewing = x > 0 && x < 100;
      var isViewed = x > 100; //[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
      // quando confirmado a migração, remover.
      // if (
      //   isViewing &&
      //   percentSendAnalytics === 0 &&
      //   lastAnalyticsScroll !== progressAnalytics
      // ) {
      //   const articleId = serverSideContext.article[index].id.replace(
      //     "policy:",
      //     ""
      //   );
      //   if (lastArticleId !== articleId) {
      //     lastArticleId = articleId;
      //     enviarPageView({
      //       referer: window?.location?.href,
      //       contentId: articleId,
      //     });
      //   }
      //   //[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
      //   // quando confirmado a migração, remover.
      //   // enviarScroll(progressAnalytics, articleId);
      //   lastAnalyticsScroll = progressAnalytics;
      // }

      if (isViewing && window.location.pathname !== i.url) {
        window.history.replaceState({}, k, i.url);

        for (var _index = 0; _index < articleContext.articles.length; _index++) {
          var site = serverSideContext.site;
          var domain = serverSideContext.domain;
          var page = serverSideContext.page;
          var article = (0,lodash.get)(articleContext.articles, _index, {});
          var articlePath = (0,lodash.get)(article, "path");
          var articleImage = article.images.length ? "".concat(domain).concat((0,useImageProxy/* useImageProxy */.n)("".concat(article.images[0].url, "f=3x2"), true)) : "";
          var itemPath = (0,lodash.get)(i, "url");

          if (articlePath === itemPath) {
            var title = window.document.head.querySelector("title");
            var meta_description = window.document.head.querySelector('meta[name="description"]');
            var meta_article_modified_time = window.document.head.querySelector('meta[property="article:modified_time"]');
            var meta_article_published_time = window.document.head.querySelector('meta[property="article:published_time"]');
            var meta_og_image = window.document.head.querySelector('meta[property="og:image"]');
            var meta_og_image_secure_url = window.document.head.querySelector('meta[property="og:image:secure_url"]');
            var meta_og_description = window.document.head.querySelector('meta[property="og:description"]');
            var meta_og_title = window.document.head.querySelector('meta[property="og:title"]');
            var meta_og_url = window.document.head.querySelector('meta[property="og:url"]');
            var meta_twitter_image = window.document.head.querySelector('meta[name="twitter:image"]');
            var meta_twitter_title = window.document.head.querySelector('meta[name="twitter:title"]');
            var meta_twitter_description = window.document.head.querySelector('meta[name="twitter:description"]');
            var responsavel = window.document.head.querySelector('meta[name="responsavel"]');
            var articleEditoria = window.document.head.querySelector('meta[name="article:editoria"]');
            var imageUrl = window.document.head.querySelector('meta[name="gjc:rec:image"]');
            var sectionUrl = window.document.head.querySelector('meta[name="cXenseParse:recs:ojc-sectionurl"]');
            var section = window.document.head.querySelector('meta[name="article:section"]');
            var author = window.document.head.querySelector('meta[name="author"]');
            var keywords = window.document.head.querySelector('meta[name="keywords"]');
            var articleName = article.metadataTitle !== "" ? article.metadataTitle : "".concat(article.name, " | ").concat(site.name);
            var articleDescription = article.metadataDescription !== "" ? article.metadataDescription : article.lead;
            var articlePublishedDate = (0,parseTime/* formatTimeToISO */.N)(article === null || article === void 0 ? void 0 : article.modificationTime);
            var articleModifiedDate = (0,parseTime/* formatTimeToISO */.N)(article === null || article === void 0 ? void 0 : article.publishingTime);
            var articleUrl = "".concat(domain).concat(article.path);

            if (title) {
              title.innerHTML = articleName;
            }

            if (meta_description) {
              meta_description.content = articleDescription;
            }

            if (meta_article_modified_time) {
              meta_article_modified_time.content = articleModifiedDate;
            }

            if (meta_article_published_time) {
              meta_article_published_time.content = articlePublishedDate;
            }

            if (meta_og_image) {
              meta_og_image.content = articleImage;
            }

            if (meta_og_image_secure_url) {
              meta_og_image_secure_url.content = articleImage;
            }

            if (meta_og_description) {
              meta_og_description.content = articleDescription;
            }

            if (meta_og_title) {
              meta_og_title.content = articleName;
            }

            if (meta_og_url) {
              meta_og_url.content = articleUrl;
            }

            if (meta_twitter_image) {
              meta_twitter_image.content = articleImage;
            }

            if (meta_twitter_title) {
              meta_twitter_title.content = articleName;
            }

            if (meta_twitter_description) {
              meta_twitter_description.content = articleDescription;
            }

            if (responsavel) {
              var _article$author;

              responsavel.content = article !== null && article !== void 0 && (_article$author = article.author) !== null && _article$author !== void 0 && _article$author.name ? article.author.name : article.byline;
            }

            if (articleEditoria) {
              articleEditoria.content = page.name;
            }

            if (imageUrl) {
              imageUrl.content = articleImage;
            }

            if (sectionUrl) {
              sectionUrl.content = "".concat(site.siteDomain).concat(page.path);
            }

            if (section) {
              section.content = parseMainSection(page.path);
            }

            if (author) {
              var _article$author2;

              author.content = article !== null && article !== void 0 && (_article$author2 = article.author) !== null && _article$author2 !== void 0 && _article$author2.name ? article.author.name : article.byline;
            }

            if (keywords) {
              var _article$tags;

              keywords.content = parseArticleKeywords((article === null || article === void 0 ? void 0 : (_article$tags = article.tags) === null || _article$tags === void 0 ? void 0 : _article$tags.tags) || null);
            }
          }
        }
      }

      newState[k] = {
        viewing: isViewing,
        viewed: isViewed,
        top: i.top,
        bottom: i.bottom,
        height: i.height,
        progress: progress,
        url: i.url
      };
    });
    setState(newState);
  }

  (0,react.useEffect)(function () {
    var pageType = searchArticleCid(window.location.pathname);

    if ((pageType === null || pageType === void 0 ? void 0 : pageType.type) === "article" && articleContext.isLoaded === true) {
      window.addEventListener("scroll", function () {
        return handleScroll();
      }, {
        signal: scrollListenerController.signal
      });
      window.scrollTo(0, 1);
    }

    return function () {
      scrollListenerController.abort();
    };
  }, [articleContext.isLoaded]);
  (0,react.useEffect)(function () {
    scrollListenerController.abort();
  }, [router.asPath]);
  (0,react.useEffect)(function () {
    var tp = window.tp || [];
    tp.push(["setPageURL", window.location.href]);

    if (keycloak) {
      var _tp$pianoId;

      (_tp$pianoId = tp.pianoId) === null || _tp$pianoId === void 0 ? void 0 : _tp$pianoId.loginByToken((0,ecryption/* decrypt */.p)(keycloak.token)).then(function () {
        var _tp$experience;

        (_tp$experience = tp.experience) === null || _tp$experience === void 0 ? void 0 : _tp$experience.execute();
      });
    } else {
      var _tp$pianoId2, _tp$experience2;

      if ((tp === null || tp === void 0 ? void 0 : (_tp$pianoId2 = tp.pianoId) === null || _tp$pianoId2 === void 0 ? void 0 : _tp$pianoId2.getUser()) !== null) {
        var _tp$pianoId3;

        tp === null || tp === void 0 ? void 0 : (_tp$pianoId3 = tp.pianoId) === null || _tp$pianoId3 === void 0 ? void 0 : _tp$pianoId3.logout();
      }

      (_tp$experience2 = tp.experience) === null || _tp$experience2 === void 0 ? void 0 : _tp$experience2.execute();
    }
  }, [window.location.href]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ArticleScrollContext.Provider, {
    value: {
      state: state
    },
    children: props.children
  });
};

/* harmony default export */ var ArticleScroll = (ArticleScrollProvider);

/***/ }),

/***/ 1187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FilterContext": function() { return /* binding */ FilterContext; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var initialState = {
  date: null,
  departments: [],
  pageRows: 0,
  pageStart: 0,
  policyId: '',
  term: '',
  tag: ''
};
var FilterContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
  filters: {},
  sideBoxFilter: '1',
  updateFilter: function updateFilter() {
    return null;
  },
  updateSideBoxFilter: function updateSideBoxFilter() {
    return null;
  }
});

var FilterProvider = function FilterProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}),
      filters = _useState[0],
      setFilters = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)('1'),
      sideBoxFilter = _useState2[0],
      setSideBoxFilter = _useState2[1];

  var updateFilter = function updateFilter(policyId, data) {
    var keys = Object.keys(filters);
    var selectedKey = keys[policyId] || policyId;
    var selectedFilter = filters[selectedKey];
    setFilters(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, (0,_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, selectedKey, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, initialState), selectedFilter), data), {}, {
        policyId: policyId
      })));
    });
  };

  var updateSideBoxFilter = function updateSideBoxFilter(param) {
    setSideBoxFilter(param);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(FilterContext.Provider, {
    value: {
      filters: filters,
      sideBoxFilter: sideBoxFilter,
      updateFilter: updateFilter,
      updateSideBoxFilter: updateSideBoxFilter
    },
    children: children
  });
};

/* harmony default export */ __webpack_exports__["default"] = (FilterProvider);

/***/ }),

/***/ 5341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FilterDataContext": function() { return /* binding */ FilterDataContext; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7812);
/* harmony import */ var _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _providers_actions_loadByCid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2078);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var FilterDataContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
  collections: {},
  items: [],
  loading: false,
  totalItems: 0,
  loadSearchEngineData: function loadSearchEngineData() {
    return null;
  }
});

var FilterDataProvider = function FilterDataProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}),
      state = _useState[0],
      setState = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0),
      totalItems = _useState3[0],
      setTotalItems = _useState3[1];

  var handleSearchEngineState = function handleSearchEngineState(policyId, payload) {
    setState(function (prevState) {
      setLoading(false);
      var totalItems = payload.success ? payload.totalItems : 0;
      return _objectSpread(_objectSpread({}, prevState), {}, (0,_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, policyId, {
        data: (0,_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(payload.pageData),
        totalItems: totalItems
      }));
    });
  };

  var handlePaginatedState = function handlePaginatedState(policyId, payload) {
    setState(function (prevState) {
      setLoading(false);
      var selectedPrevState = prevState[policyId] ? prevState[policyId].data : [];
      var totalItems = payload.success ? payload.totalItems : 0;
      return _objectSpread(_objectSpread({}, prevState), {}, (0,_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, policyId, {
        data: [].concat((0,_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(selectedPrevState), (0,_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(payload.pageData)),
        totalItems: totalItems
      }));
    });
  };

  var loadSearchEngineData = function loadSearchEngineData(data, options) {
    var _data$categorization, _data$departments;

    setLoading(true);
    var policyId = data.policyId;
    var parsedFilters = {
      policyId: policyId
    };

    if (((_data$categorization = data.categorization) === null || _data$categorization === void 0 ? void 0 : _data$categorization.length) !== 0) {
      parsedFilters['categorization'] = data.categorization;
    }

    if (data.dateStart) {
      parsedFilters['dateStart'] = data.dateStart;
    }

    if (data.dateEnd) {
      parsedFilters['dateEnd'] = data.dateEnd;
    }

    if (((_data$departments = data.departments) === null || _data$departments === void 0 ? void 0 : _data$departments.length) !== 0) {
      var _data$departments2;

      parsedFilters['departments'] = (_data$departments2 = data.departments) === null || _data$departments2 === void 0 ? void 0 : _data$departments2.map(function (i) {
        return i.replace('policy:', '');
      }).join(' OR ');
    }

    if (data.inputTemplate !== '') {
      parsedFilters['inputTemplate'] = data.inputTemplate;
    }

    if (typeof data.pageRows === 'number') {
      parsedFilters['pageRows'] = data.pageRows;
    }

    if (typeof data.pageStart === 'number') {
      parsedFilters['pageStart'] = data.pageStart;
    }

    if (data.searchTag !== '') {
      parsedFilters['searchTag'] = data.searchTag;
    }

    if (data.searchText !== '') {
      parsedFilters['searchText'] = data.searchText;
    }

    var setterFunction = function setterFunction(payload) {
      if (payload.success === true) {
        if (options.isPaginated) {
          handlePaginatedState(policyId, payload);
        }

        if (options.isSearchEngine) {
          handleSearchEngineState(policyId, payload);
        }
      }
    };

    (0,_providers_actions_loadByCid__WEBPACK_IMPORTED_MODULE_2__/* .loadByCidFilter */ .v9)(parsedFilters, setterFunction);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(FilterDataContext.Provider, {
    value: {
      items: [],
      loading: loading,
      totalItems: totalItems,
      collections: state,
      loadSearchEngineData: loadSearchEngineData
    },
    children: children
  });
};

/* harmony default export */ __webpack_exports__["default"] = (FilterDataProvider);

/***/ }),

/***/ 9859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PagesContext": function() { return /* binding */ PagesContext; }
/* harmony export */ });
/* harmony import */ var providers_actions_loadByCid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2078);
/* harmony import */ var providers_ServerSideProps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8991);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var providers_Session_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8717);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5893);
/* eslint-disable react-hooks/exhaustive-deps */


 // import { enviarPageView } from 'hooks/useGCJAnalytics'




var PagesContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)({});

var PagesProvider = function PagesProvider(_ref) {
  var children = _ref.children;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
  var serverSideContext = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(providers_ServerSideProps__WEBPACK_IMPORTED_MODULE_1__.ServerSidePropsContext);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      articles = _useState[0],
      setArticles = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(serverSideContext.domain),
      domain = _useState2[0],
      setDomain = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}),
      pageData = _useState3[0],
      setPageData = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}),
      pageList = _useState4[0],
      setPageList = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      pageListData = _useState5[0],
      setPageListData = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      pageLoading = _useState6[0],
      setPageLoading = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
    type: '',
    departmentSlug: ''
  }),
      pageType = _useState7[0],
      setPageType = _useState7[1];

  var _useState8 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(serverSideContext.navigation),
      navigation = _useState8[0],
      setNavigation = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}),
      siteData = _useState9[0],
      setSiteData = _useState9[1];

  var _useState10 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''),
      siteExtId = _useState10[0],
      setSiteExtId = _useState10[1];

  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}),
      siteList = _useState11[0],
      setSiteList = _useState11[1];

  var _useState12 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''),
      siteName = _useState12[0],
      setSiteName = _useState12[1];

  var sessionData = (0,providers_Session_utils__WEBPACK_IMPORTED_MODULE_5__/* .getSessionDataFromCookie */ .o9)();

  var loadArticle = function loadArticle() {
    setPageLoading(true);
    (0,providers_actions_loadByCid__WEBPACK_IMPORTED_MODULE_0__/* .loadByContentList */ ._p)(serverSideContext.pageSlots, sessionData).then(function (response) {
      setPageType(serverSideContext.pageType);
      setNavigation(serverSideContext.navigation);
      setArticles(serverSideContext.article);
      setPageData(serverSideContext.page);
      setPageList(serverSideContext.pageSlots);
      setPageListData(response);
      setSiteData(serverSideContext.site);
      setSiteExtId(serverSideContext.site.extid);
      setSiteList(serverSideContext.siteSlots);
      setSiteName(serverSideContext.site.name);
      setPageLoading(false);
    })["catch"](function (e) {
      console.log('[Fetch error :: loadArticle]', e);
      setPageLoading(false);
    });
  };

  var loadDepartment = function loadDepartment() {
    setPageLoading(true);
    (0,providers_actions_loadByCid__WEBPACK_IMPORTED_MODULE_0__/* .loadByContentList */ ._p)(serverSideContext.pageSlots, sessionData).then(function (response) {
      setPageType(serverSideContext.pageType);
      setNavigation(serverSideContext.navigation);
      setArticles([]);
      setPageData(serverSideContext.page);
      setPageList(serverSideContext.pageSlots);
      setPageListData(response);
      setSiteData(serverSideContext.site);
      setSiteExtId(serverSideContext.site.extid);
      setSiteList(serverSideContext.siteSlots);
      setSiteName(serverSideContext.site.name);
      setPageLoading(false);
    })["catch"](function (e) {
      console.log('[Fetch error :: loadDepartment]', e);
      setPageLoading(false);
    });
  };

  var loadHome = function loadHome() {
    setPageLoading(true);
    (0,providers_actions_loadByCid__WEBPACK_IMPORTED_MODULE_0__/* .loadByContentList */ ._p)(serverSideContext.siteSlots, sessionData).then(function (response) {
      setPageType(serverSideContext.pageType);
      setNavigation(serverSideContext.navigation);
      setArticles([]);
      setPageData(serverSideContext.page);
      setPageList(serverSideContext.siteSlots);
      setPageListData(response);
      setSiteData(serverSideContext.site);
      setSiteExtId(serverSideContext.site.extid);
      setSiteList(serverSideContext.siteSlots);
      setSiteName(serverSideContext.site.name);
      setPageLoading(false);
    })["catch"](function (e) {
      console.log('[Fetch error :: loadHome]', e);
      setPageLoading(false);
    });
  };

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (serverSideContext.pageType.type === 'article') {
      loadArticle();
    } else if (serverSideContext.pageType.type === 'department') {
      loadDepartment(); //[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
      // quando confirmado a migração, remover.
      // enviarPageView({ referer: window?.location?.href, contentId: serverSideContext.page.id.replace('policy:', '') });
    } else if (serverSideContext.pageType.type === 'home') {
      loadHome(); //[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
      // quando confirmado a migração, remover.
      //  enviarPageView({ referer: window?.location?.href, contentId: serverSideContext.site?.id.replace('policy:', '') });
    }
  }, [router.asPath]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(PagesContext.Provider, {
    value: {
      articles: articles,
      domain: domain,
      navigation: navigation,
      pageData: pageData,
      pageList: pageList,
      pageListData: pageListData,
      pageLoading: pageLoading,
      pageType: pageType,
      siteData: siteData,
      siteExtId: siteExtId,
      siteList: siteList,
      siteName: siteName
    },
    children: children
  });
};

/* harmony default export */ __webpack_exports__["default"] = (PagesProvider);

/***/ }),

/***/ 2078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_p": function() { return /* binding */ loadByContentList; },
/* harmony export */   "v9": function() { return /* binding */ loadByCidFilter; }
/* harmony export */ });
/* unused harmony exports loadByCid, loadImageByContentList */
/* harmony import */ var _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29);
/* harmony import */ var _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7794);
/* harmony import */ var _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var mobile_detect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2437);
/* harmony import */ var mobile_detect__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(mobile_detect__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4887);
/* harmony import */ var _utils_debugTools__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1263);
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4987);





 // Função para aplicar timeout

var timeout = function timeout(ms) {
  return new Promise(function (_, reject) {
    return setTimeout(function () {
      return reject(new Error("Timeout"));
    }, ms);
  });
}; // Função que faz a requisição com timeout, limitando o tempo total a 2 segundos


var fetchWithTimeout = /*#__PURE__*/function () {
  var _ref = (0,_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(url, payload, cid) {
    var maxRetries,
        timeoutMs,
        attempt,
        result,
        _ret,
        _args2 = arguments;

    return _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            maxRetries = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : 3;
            timeoutMs = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : 3000;
            attempt = 0;
            result = null;

          case 4:
            if (!(attempt < maxRetries)) {
              _context2.next = 20;
              break;
            }

            _context2.prev = 5;
            return _context2.delegateYield( /*#__PURE__*/_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
              var controller, signal, fetchTimeout, response;
              return _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      controller = new AbortController();
                      signal = controller.signal;
                      fetchTimeout = setTimeout(function () {
                        controller.abort();
                      }, timeoutMs);
                      response = void 0;

                      if (!(payload.email === undefined || !payload.email)) {
                        _context.next = 10;
                        break;
                      }

                      _context.next = 7;
                      return fetch(url, {
                        method: 'GET',
                        headers: {
                          'Content-Type': 'application/json'
                        },
                        signal: signal
                      });

                    case 7:
                      response = _context.sent;
                      _context.next = 14;
                      break;

                    case 10:
                      if (cid.includes('1.')) {
                        _context.next = 14;
                        break;
                      }

                      _context.next = 13;
                      return fetch(url, {
                        method: 'POST',
                        body: JSON.stringify(payload),
                        headers: {
                          'Content-Type': 'application/json'
                        },
                        signal: signal
                      });

                    case 13:
                      response = _context.sent;

                    case 14:
                      clearTimeout(fetchTimeout);

                      if (response.ok) {
                        _context.next = 17;
                        break;
                      }

                      throw new Error("HTTP error! status: ".concat(response.status));

                    case 17:
                      _context.next = 19;
                      return response.json();

                    case 19:
                      result = _context.sent;
                      console.log("[DEBUG] Sucesso: ", result);

                      if (!result) {
                        _context.next = 23;
                        break;
                      }

                      return _context.abrupt("return", {
                        v: result
                      });

                    case 23:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            })(), "t0", 7);

          case 7:
            _ret = _context2.t0;

            if (!(typeof _ret === "object")) {
              _context2.next = 10;
              break;
            }

            return _context2.abrupt("return", _ret.v);

          case 10:
            _context2.next = 17;
            break;

          case 12:
            _context2.prev = 12;
            _context2.t1 = _context2["catch"](5);
            _utils_debugTools__WEBPACK_IMPORTED_MODULE_3__/* .debugTools.log */ .C.log("[DEBUG] Tentativa falhou: ", _context2.t1);
            console.log("[DEBUG] Tentativa para o id falhou: ", cid);
            console.log("[DEBUG] Tentativa falhou: ", _context2.t1);

          case 17:
            attempt++;
            _context2.next = 4;
            break;

          case 20:
            throw new Error("Failed to fetch after ".concat(maxRetries, " attempts"));

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[5, 12]]);
  }));

  return function fetchWithTimeout(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var handlePromiseResult = function handlePromiseResult(result) {
  var fulfilledSlots = [];
  result.forEach(function (res) {
    return res.status === "fulfilled" && res.value.forEach(function (content) {
      return fulfilledSlots.push(content);
    });
  });
  return fulfilledSlots;
};

var loadByContentList = /*#__PURE__*/function () {
  var _ref2 = (0,_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(data, session) {
    var absoluteUrl,
        contentKeys,
        contentList,
        promisesList,
        md,
        deviceType,
        payload,
        _i,
        _contentList,
        cid,
        fetchResult,
        fulfilledSlots,
        _args3 = arguments;

    return _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            absoluteUrl = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : "";
            contentKeys = Object.keys(data);
            contentList = [];
            promisesList = [];
            md = new (mobile_detect__WEBPACK_IMPORTED_MODULE_1___default())(window.navigator.userAgent);
            deviceType = md.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i) ? "MOBILE" : "DESKTOP";
            payload = {
              email: session === null || session === void 0 ? void 0 : session.emailUsuario,
              product: "OPOPULAR",
              deviceType: deviceType,
              sessionId: session === null || session === void 0 ? void 0 : session.id
            };
            contentKeys.forEach(function (key) {
              return data[key].forEach(function (cid) {
                return cid && contentList.push((0,_util__WEBPACK_IMPORTED_MODULE_4__/* .castContentIdString */ .np)(cid));
              });
            });

            for (_i = 0, _contentList = contentList; _i < _contentList.length; _i++) {
              cid = _contentList[_i];
              _utils_debugTools__WEBPACK_IMPORTED_MODULE_3__/* .debugTools.log */ .C.log("[DEBUG] (loadByContentList) postFetchApi: ", "".concat(absoluteUrl, "/siteApi/contentId/").concat(cid), payload);
              promisesList.push(fetchWithTimeout("".concat(absoluteUrl, "/siteApi/contentId/").concat(cid), payload, cid));
            }

            _context3.prev = 9;
            _context3.next = 12;
            return Promise.allSettled(promisesList);

          case 12:
            fetchResult = _context3.sent;
            fulfilledSlots = handlePromiseResult(fetchResult);
            _utils_debugTools__WEBPACK_IMPORTED_MODULE_3__/* .debugTools.log */ .C.log("[DEBUG] (loadByContentList) fulfilledSlots: ", fulfilledSlots);
            return _context3.abrupt("return", fulfilledSlots);

          case 18:
            _context3.prev = 18;
            _context3.t0 = _context3["catch"](9);
            _utils_debugTools__WEBPACK_IMPORTED_MODULE_3__/* .debugTools.log */ .C.log("[DEBUG] (loadByContentList) [Fetch error :: loadByContentList]: ", _context3.t0);
            return _context3.abrupt("return", []);

          case 22:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[9, 18]]);
  }));

  return function loadByContentList(_x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

var loadImageByContentList = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(contentList) {
    var promisesArray, data, promiseResult;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            promisesArray = contentList.map(function (image_url) {
              return image_url ? fetch(image_url) : null;
            }).filter(Boolean);
            data = [];
            _context4.next = 4;
            return Promise.allSettled(promisesArray);

          case 4:
            promiseResult = _context4.sent;
            promiseResult.forEach(function (item) {
              if (item.status === "fulfilled") {
                (item === null || item === void 0 ? void 0 : item.value) && data.push(item === null || item === void 0 ? void 0 : item.value);
              }
            });
            return _context4.abrupt("return", data);

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function loadImageByContentList(_x6) {
    return _ref3.apply(this, arguments);
  };
}())); // Função para carregar dados por CID de forma não bloqueante


var loadByCid = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(cid) {
    var absoluteUrl,
        session,
        device,
        payload,
        _args5 = arguments;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            absoluteUrl = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : "";
            session = _args5.length > 2 ? _args5[2] : undefined;
            device = _args5.length > 3 ? _args5[3] : undefined;
            payload = {
              email: session === null || session === void 0 ? void 0 : session.emailUsuario,
              product: "OPOPULAR",
              deviceType: device,
              polopolyContent: {
                contentId: cid,
                accessLevel: session === null || session === void 0 ? void 0 : session.nivelAcesso
              },
              sessionId: session === null || session === void 0 ? void 0 : session.id
            };
            debugTools.log("[DEBUG] (loadByCid) postApiPaywall: ", "".concat(absoluteUrl, "/siteApi/contentId/").concat(cid), payload);
            return _context5.abrupt("return", postApiPaywall("".concat(absoluteUrl, "/siteApi/contentId/").concat(cid), payload));

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function loadByCid(_x7) {
    return _ref4.apply(this, arguments);
  };
}())); // Função para carregar filtros com callbacks, sem bloquear o fluxo


var loadByCidFilter = function loadByCidFilter(params, callback) {
  var parsedData = "".concat(query_string__WEBPACK_IMPORTED_MODULE_2__/* ["default"].stringify */ .Z.stringify(params));
  var url = "/siteApi/filter/".concat(params.policyId, "?").concat(parsedData);
  (0,_util__WEBPACK_IMPORTED_MODULE_4__/* .fetchApi */ .a8)(url).then(function (response) {
    return callback(response);
  })["catch"](function (e) {
    return console.log("[Fetch Error :: loadDataByCidFilter]: ", e);
  });
};



/***/ }),

/***/ 4987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a8": function() { return /* binding */ fetchApi; },
/* harmony export */   "np": function() { return /* binding */ castContentIdString; }
/* harmony export */ });
/* unused harmony exports postFetchApi, deleteApiPaywall, postApiPaywall, patchCreditsEarnedPaywall, postApi */
/* harmony import */ var _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29);
/* harmony import */ var _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7794);
/* harmony import */ var _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);




var castContentIdString = function castContentIdString(contentId) {
  var replacements = [{
    from: "contentid/",
    to: ""
  }, {
    from: "policy:/",
    to: ""
  }, {
    from: "policy:",
    to: ""
  }];
  var contentIdString = contentId || "";
  replacements === null || replacements === void 0 ? void 0 : replacements.map(function (r) {
    contentIdString = contentIdString.replace(r.from, r.to);
  });
  return contentIdString;
};
var fetchApi = /*#__PURE__*/function () {
  var _ref = (0,_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url) {
    var res;
    return _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch(url);

          case 3:
            res = _context.sent;
            return _context.abrupt("return", res.json());

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            console.log("e", _context.t0);
            return _context.abrupt("return", []);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function fetchApi(_x) {
    return _ref.apply(this, arguments);
  };
}();
var postFetchApi = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url, payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return fetch(url, {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify(payload)
            });

          case 3:
            res = _context2.sent;
            return _context2.abrupt("return", res.json());

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            console.log("e", _context2.t0);
            return _context2.abrupt("return", []);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7]]);
  }));

  return function postFetchApi(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}()));
var deleteApiPaywall = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(url) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return axios["delete"](url).then(function (res) {
              return res;
            })["catch"](function (err) {
              var res = get(err, "response.data", {});
              return res;
            });

          case 2:
            return _context3.abrupt("return", _context3.sent);

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function deleteApiPaywall(_x4) {
    return _ref3.apply(this, arguments);
  };
}()));
var postApiPaywall = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(url, body) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return axios.post(url, body, {
              headers: {
                "Content-Type": "application/json"
              },
              withCredentials: true
            }).then(function (res) {
              return res;
            })["catch"](function (err) {
              var res = get(err, "response.data", {});
              console.log("err", res);
              return res;
            });

          case 2:
            return _context4.abrupt("return", _context4.sent);

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function postApiPaywall(_x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}()));
var patchCreditsEarnedPaywall = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(url) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return axios.patch(url, {
              headers: {
                "Content-Type": "application/json"
              },
              withCredentials: true
            }).then(function (res) {
              return res;
            })["catch"](function (err) {
              var res = get(err, "response.data", {});
              console.log("err", res);
              return res;
            });

          case 2:
            return _context5.abrupt("return", _context5.sent);

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function patchCreditsEarnedPaywall(_x7) {
    return _ref5.apply(this, arguments);
  };
}()));
var postApi = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(url, body) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return axios.post(url, body, {
              headers: {
                "Content-Type": "application/json"
              },
              withCredentials: true
            }).then(function (res) {
              return res.data;
            })["catch"](function (err) {
              var res = get(err, "response.data", {});
              console.log("err", res);
              return res;
            });

          case 2:
            return _context6.abrupt("return", _context6.sent);

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function postApi(_x8, _x9) {
    return _ref6.apply(this, arguments);
  };
}()));

/***/ }),

/***/ 3119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ decrypt; }
/* harmony export */ });
/* unused harmony export encrypt */
/* harmony import */ var cryptr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7946);
/* harmony import */ var cryptr__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(cryptr__WEBPACK_IMPORTED_MODULE_0__);

function encrypt(text) {
  var secretKey = "XwB+gHI9+9oONq/raYHYPaoooLPZjl9F9aTsXSNZ+IU=" || 0;
  var cryptr = new Cryptr(secretKey);
  var encryptedString = cryptr.encrypt(text || "");
  return encryptedString;
}
function decrypt(encryptedString) {
  var secretKey = "XwB+gHI9+9oONq/raYHYPaoooLPZjl9F9aTsXSNZ+IU=" || 0;
  var cryptr = new (cryptr__WEBPACK_IMPORTED_MODULE_0___default())(secretKey);
  var text = cryptr.decrypt(encryptedString || "");
  return text;
}

/***/ }),

/***/ 586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ getPageTitleFromPath; }
/* harmony export */ });
/* unused harmony export getDepFromNav */
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3311);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);


var getDepFromNav = function getDepFromNav(navigation, pathName) {
  var pathParsed = pathName;
  var items = [];
  var itemSelected = {};

  if (!!pathParsed) {
    navigation === null || navigation === void 0 ? void 0 : navigation.map(function (pqueue) {
      pqueue === null || pqueue === void 0 ? void 0 : pqueue.map(function (queue) {
        var _queue$contentData;

        queue === null || queue === void 0 ? void 0 : (_queue$contentData = queue.contentData) === null || _queue$contentData === void 0 ? void 0 : _queue$contentData.map(function (entry) {
          items.push(entry);
        });
      });
    });
    items === null || items === void 0 ? void 0 : items.map(function (item) {
      var _item$path;

      if (item !== null && item !== void 0 && (_item$path = item.path) !== null && _item$path !== void 0 && _item$path.endsWith(pathParsed)) {
        itemSelected = item;
      }
    });
  }

  return itemSelected;
};
var getPageTitleFromPath = function getPageTitleFromPath(nav, d) {
  var getFromList = function getFromList(p) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(lodash_find__WEBPACK_IMPORTED_MODULE_0___default()(nav, {
      path: p
    }), 'name');
  };

  var slugs = [];
  var s = d.split('/');

  if (s.length > 3) {
    slugs.push("/".concat(s[1], "/").concat(s[2], "/").concat(s[3]));
  } else if (s.length > 2) {
    slugs.push("/".concat(s[1], "/").concat(s[2]));
  } else if (s.length > 1) {
    slugs.push("/".concat(s[1]));
  }

  var titles = [];

  for (var i = 0; i < slugs.length; i++) {
    titles.push(getFromList(slugs[i]));
  }

  return titles;
};

/***/ })

}]);